import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink, HashRouter } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CancelButtonLink } from "../../../components/Buttons";
import {
  WizardTitle,
  notifyError,
  PageHeightAuto,
  notifyInfo,
  CoverText,
  PageHeight20,
} from "../../../components/Utils";
import Dashboard from "../../../components/Dashboard";
import ImportForm from "../../../components/ImportForm";
// import { reasonTemplate } from "../../Reporting/components/RecordsTable";

const WorkerNgumIDImportWizard = ({ history }) => {
  const [imported, setImported] = useState(null);
  const [rejected, setRejected] = useState(null);
  const [isNewProfile, setIsNewProfile] = useState(false);
  const [isChangeProfile, setIsChangeProfile] = useState(false);
  const [importSuccess, setImportSuccess] = useState(false);
  const [totalEmployees, setTotalEmployees] = useState(undefined);

  useEffect(() => {
    if (importSuccess) {
      const summary = `nGUM IDs Importieren`;
      setTimeout(() => {
        notifyInfo({
          summary,
          detail: `Die nGUM IDs wurden erfolgreich importiert.`,
        });
        history.push("/organisation/mitarbeiter");
      }, 2000);
    }
  }, [importSuccess, history]);

  const handleError = (event) => {
    const error = event.xhr.response;
    const errorMessage = error && error.message;
    notifyError({
      summary: "Importfehler",
      detail: errorMessage,
    });
    setImported([]);
    setRejected([]);
  };

  const handleSuccess = (event) => {
    console.log("Import succeeded:", event);
    /* //===================================//
    // temporary solution
    setImportSuccess(true);
    //===================================// */
    const result = event.xhr.response;
    setImported(result.imported);
    // to keep the `rejected` structure similar to the `imported` structure
    setRejected(
      result.rejected.map(({ record, ...other }) => ({ ...record, ...other })),
    );
    setIsNewProfile(result.isNewProfile);
    setIsChangeProfile(result.isChangeProfile);
    setTotalEmployees(result.totalEmployees);
  };

  const handleCancel = () => {
    history.push("/organisation/mitarbeiter");
  };

  const renderMenu = () => {
    let rejectedLink;
    if (rejected) {
      rejectedLink = (
        <li>
          <NavLink to={`/abgelehnt`} activeClassName="active">
            {"Abgelehnt"}
          </NavLink>
        </li>
      );
    }
    let importedLink;
    if (imported) {
      importedLink = (
        <li>
          <NavLink to={`/importiert`} activeClassName="active">
            {"Importiert"}
          </NavLink>
        </li>
      );
    }
    return (
      <HashRouter>
        <div className="under-wizard-title">
          <div className="margin-big-top nav-menu-vertical">
            <ul className="w3-ul w3-border w3-round- w3-large">
              <li>
                <NavLink to={`/upload`} activeClassName="active">
                  {"CSV hochladen"}
                </NavLink>
              </li>
              {importedLink}
              {rejectedLink}
            </ul>
          </div>
        </div>
      </HashRouter>
    );
  };

  const renderImported = () => {
    if (imported === null) {
      return null;
    }
    const isUpdating = isChangeProfile === true;
    let message = <>{`Keine importierten nGUM IDs`}</>;
    if (imported.length > 0) {
      message = (
        <>
          <b>{`${imported.length} von ${totalEmployees} nGUM IDs`}</b>
          {` wurde${imported.length > 1 ? "n" : ""} erfolgreich ${isUpdating ? "angepasst" : "neu importiert"}.`}
        </>
      );
    }
    return (
      <PageHeight20
        id="/importiert"
        className="w3-border margin-big-top pad-big"
        isUnterWizardTitle
      >
        <h3 className="no-margin-top">{`Erfolgreiche ${isUpdating ? "Änderungen" : "Importe"}`}</h3>
        <PageHeight20>
          <CoverText>
            <h4 className="no-margin display-inline">{message}</h4>
          </CoverText>
        </PageHeight20>
      </PageHeight20>
    );
  };

  const renderRejected = () => {
    if (rejected === null) {
      return null;
    }
    const isUpdating = isChangeProfile === true;
    let markup = (
      <CoverText>
        <h4 className="no-margin display-inline">
          {`Keine abgelehnten nGUM IDs`}
        </h4>
      </CoverText>
    );
    if (rejected.length > 0) {
      //
      const items = rejected.map((record) => {
        const copy = {
          ...record,
          contractGiver: record["KDL / DL"],
        };
        if (record.Vorname) {
          copy.employee = `${record.Vorname} ${record.Nachname}`;
        }
        if (record.Mitarbeiterprofil) {
          copy.username = record.Mitarbeiterprofil;
        }
        return copy;
      });
      const columnStyle = {
        verticalAlign: "top",
        paddingTop: "16px",
        paddingBottom: "16px",
      };
      markup = (
        <DataTable value={items} className="records-table" paginator rows={10}>
          <Column
            field="vf_email"
            header="Vodafone E-Mail"
            style={{ ...columnStyle, width: "20em" }}
          />
          <Column
            field="ngumUserId"
            header="nGUM ID"
            style={{ ...columnStyle, width: "20em" }}
          />
          <Column
            field="errors"
            header="Fehlermeldungen"
            style={columnStyle}
            body={(item) => (
              <>
                {item.errors.map((value, index) => (
                  <label key={`error${index}`} className="w3-block">
                    {value}
                  </label>
                ))}
              </>
            )}
          />
        </DataTable>
      );
    }
    return (
      <PageHeightAuto
        id="/abgelehnt"
        className="w3-border margin-big-top pad-big"
        isUnterWizardTitle
      >
        <h3 className="no-margin-top">{`Abgelehnte ${isUpdating ? "Änderungen" : "Importe"}`}</h3>
        <PageHeight20>{markup}</PageHeight20>
      </PageHeightAuto>
    );
  };

  // const { type } = props;
  console.log(
    "WorkerNgumIDImportWizard.render() \nprops",
    { history },
    "\nstate",
    {
      imported,
      rejected,
      totalEmployees,
      isNewProfile,
      isChangeProfile,
      importSuccess,
    },
  );
  const Menu = renderMenu();
  const rejectedSection = renderRejected();
  const importedSection = renderImported();

  return (
    <div className="clearfix">
      <WizardTitle
        type={`ngum-id-import`}
        menu={
          <div className="pad-big-top">
            <CancelButtonLink onCancel={handleCancel} />
          </div>
        }
      />
      <div className="container">
        <Dashboard menu={Menu} menuSize={3}>
          <PageHeightAuto
            id="/upload"
            className="w3-border margin-big-top pad-big"
            isUnterWizardTitle
          >
            <h3 className="no-margin-top">CSV hochladen</h3>
            <ImportForm
              url={`/data-api/companies/employees/import/ngum-ids`}
              onError={handleError}
              onUpload={handleSuccess}
              // disabled={imported !== null || rejected !== null}
            />
          </PageHeightAuto>
          {importedSection}
          {rejectedSection}
        </Dashboard>
      </div>
    </div>
  );
};

WorkerNgumIDImportWizard.propTypes = {
  history: PropTypes.object,
};

export default WorkerNgumIDImportWizard;
